<template>
  <div id="app">
<!--    <w-s-connect server="192.168.10.31" port="7500"></w-s-connect>-->
    <nav-bar/>
    <router-view/>
  </div>
</template>


<script>
import NavBar from "@/components/NavBar";
// import WSConnect from "@/components/WSConnect";
// import Vue from 'vue'
export default {
  components: {NavBar},
  // components: {WSConnect, NavBar},
  created() {
    // console.log(this)
      this.$socketClient.onOpen = () => {
      // this.$websocket.onopen = () => {
        this.$store.dispatch('socketConnected', true)
        console.log('onOpen')
        this.$store.dispatch('sendMessage', {'event':'auth/request', 'data': {'token': this.$store.state.token}})
      }
      this.$socketClient.onMessage = msg => {
      // this.$websocket.onmessage = msg => {
      //   console.log('onmessage', msg)
        // console.log('bufferedAmount', this.$websocket.bufferedAmount)
        this.$store.dispatch('onMessage', JSON.parse(msg.data))
      }
      this.$socketClient.onClose = () => {
      // this.$websocket.onclose = () => {
      //   console.log('socket closed')
        this.$store.dispatch('socketConnected', false)
      }
      this.$socketClient.onError = () => {
      // this.$websocket.onerror = () => {
      //   console.log('socket error')
      }
    }
  }

</script>


<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>